import { render, staticRenderFns } from "./InfoMessage.vue?vue&type=template&id=858afbac"
import script from "./InfoMessage.vue?vue&type=script&lang=js"
export * from "./InfoMessage.vue?vue&type=script&lang=js"
import style0 from "./InfoMessage.vue?vue&type=style&index=0&id=858afbac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports